import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

function Dashboard() {
  const { user, logout } = useAuth();

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>Панель управления</h1>
        <div className="user-info">
          <span>Привет, {user?.username || 'Пользователь'}!</span>
          <button onClick={logout} className="logout-button">Выйти</button>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="dashboard-card">
          <h2>Добро пожаловать в систему ALCO</h2>
          <p>Это главная панель управления. Здесь будет отображаться основная информация и элементы управления.</p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
